import { GRID_ACTIONS_COLUMN_TYPE, GRID_TREE_DATA_GROUPING_FIELD } from '@mui/x-data-grid-pro';

import { LEFT_COLUMN_NAME, RIGHT_COLUMN_NAME } from '../constants';

type ColumnLike = {
  field: string | number | symbol;
  headerName?: string;
};

export const isPaddingColumn = (col: ColumnLike): boolean =>
  col.field === LEFT_COLUMN_NAME || col.field === RIGHT_COLUMN_NAME;

export const isSystemColumn = (col: ColumnLike): boolean =>
  col.field === GRID_ACTIONS_COLUMN_TYPE || col.field === GRID_TREE_DATA_GROUPING_FIELD;

export const hasValidHeader = (col: ColumnLike): boolean => Boolean(col.headerName?.trim());

export const isUserColumn = (col: ColumnLike): boolean => !isPaddingColumn(col) && !isSystemColumn(col);

export const isRealColumn = (col: ColumnLike): boolean => isUserColumn(col) && hasValidHeader(col);
